var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9528897181581665190(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.9 36.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M22.5 9.2c.5.1.9-.2 1.1-.6l1-4.2c.1-.5-.2-.9-.6-1.1l-3.9-1c-.6-.1-1.1.2-1.2.7-.1.5.2.9.6 1.1l1.7.4-11.8 8.6c-.4.3-.5.9-.2 1.2.3.4.8.5 1.2.2l12-8.7-.6 2.3c-.1.5.2 1 .7 1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M2.4 23.8h7.5v7H2.4zM13.1 17.4h7.5v13.5h-7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M31.2 25.4V24l-5.4 6.8h1.1zM31.2 23.7v-1.5l-6.8 8.6h1.1zM24.9 10.3h-1.1v1.4zM31.2 14.7v-1.4l-7.4 9.5v1.4zM31.2 16.5v-1.4l-7.4 9.4V26zM24.1 30.8l7.1-8.9v-1.5l-7.4 9.5v.9zM31.2 12.9v-1.4L23.8 21v1.4zM31.2 20.1v-1.4l-7.4 9.4v1.4zM23.8 13.5l2.5-3.2h-1.1l-1.4 1.8zM31.2 18.3v-1.4l-7.4 9.4v1.4zM23.8 17l5.3-6.7H28l-4.2 5.3zM31.2 29v-1.4l-2.6 3.2h1.2zM31.2 30.8v-1.4l-1.1 1.4h1.1zM23.8 18.8l6.7-8.5h-1.1l-5.6 7.1zM31.2 27.2v-1.4l-4 5h1.2zM23.8 15.3l3.9-5h-1.1l-2.8 3.5zM23.8 20.6l7.4-9.4v-.9h-.4l-7 8.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.8 12.1l1.4-1.8h-.3l-1.1 1.4zM23.8 13.8l2.8-3.5h-.3l-2.5 3.2zM23.8 15.6l4.2-5.3h-.3l-3.9 5zM23.8 17.4l5.6-7.1h-.3L23.8 17zM23.8 19.2l7-8.9h-.3l-6.7 8.5zM31.2 11.5v-.3l-7.4 9.4v.4zM31.2 13.3v-.4l-7.4 9.5v.4zM31.2 15.1v-.4l-7.4 9.5v.3zM31.2 16.9v-.4L23.8 26v.3zM31.2 18.7v-.4l-7.4 9.4v.4zM31.2 20.4v-.3l-7.4 9.4v.4zM31.2 22.2v-.3l-7.1 8.9h.3zM31.2 24v-.3l-5.7 7.1h.3zM31.2 25.8v-.4l-4.3 5.4h.3zM31.2 27.6v-.4l-2.8 3.6h.2zM31.2 29.4V29l-1.4 1.8h.3zM31.2 30.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M-.1 1.6v32.7c0 .2.1.5.3.6.2.2.4.3.6.3h31.9v-1.8h-31V1.6H-.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9528897181581665190);
export default __webpack_public_path__ + "static/media/9528897181581665190.c0f9d2ff616b6ad058b7e02f553dd1d6.svg";
export { ForwardRef as ReactComponent };